<template>
  <div class="p-navi-list-link-on-admin">
    <component
      :is="url === '' ? 'button' : 'a'"
      v-touch:tap
      :href="url === '' ? undefined : url"
      class="p-navi-list-link-on-admin__link"
      @mouseover="emitMouseover"
      @mouseleave="emitMouseleave"
      @click="emitClick"
    >
      <i v-if="$slots.icon" class="p-navi-list-link-on-admin__link__icon">
        <slot name="icon"></slot>
      </i>

      <span class="p-navi-list-link-on-admin__link__body">
        <span
          class="p-navi-list-link-on-admin__link__text"
          :style="{ color: hoverColor.currentHover }"
        >
          <slot name="label" />
        </span>
        <span
          v-if="notificationCount && hasNotification"
          class="p-navi-list-link-on-admin__link__notification"
        >
          <TextLabelNewArrivalCount :count="notificationCount" />
        </span>
      </span>

      <i
        v-if="childList"
        ref="arrowElement"
        class="p-navi-list-link-on-admin__link__arrow"
      >
        <IconBase
          :width="24"
          :height="24"
          view-box="0 0 24 24"
          icon-color="#3c3c3c"
        >
          <IconArrowBottom />
        </IconBase>
      </i>
    </component>
    <slot name="content"></slot>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { gsap } from "gsap";
import IconBase from "@/common/components/atoms/IconBase.vue";
import TextLabelNewArrivalCount from "@/common/components/atoms/TextLabelNewArrivalCount.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";

import commons from "@/common/store/modules/commons";

@Options({
  props: {
    url: { type: String, default: "/", required: true },
    currentElementKey: { type: Number, required: true },
    childList: { type: [Array, Boolean], required: true },
    shown: { type: Boolean, required: true },
    hasNotification: { type: [Number, String, Boolean], required: true },
    thanksPointCount: { type: Number, default: 0 }
  },
  components: {
    IconBase,
    TextLabelNewArrivalCount,
    IconArrowBottom
  },
  watch: {
    shown() {
      this.startRotateAnimationOfArrowElement();
    }
  }
})
export default class NaviListLinkOnAdmin extends Vue {
  url!: string;
  currentElementKey!: number;
  childList!: any;
  shown!: boolean;
  hasNotification!: [number, string, boolean];

  thanksPointCount!: number;

  get colorCode() {
    return commons?.colorCode;
  }

  get adminNotificationCount() {
    return commons?.userInfo.notification_count.admin;
  }

  defaultHoverColor = "#3c3c3c";
  hoverColor: any = {
    currentHover: "this.defaultHoverColor"
  };

  get notificationCount() {
    return this.thanksPointCount;
  }

  emitMouseover() {
    this.hoverColor.currentHover = this.colorCode;
    // const currentElementKey = this;
    // const hoverColor = this;
    // const colorCode = this;
    // this.hoverColor.currentHover = colorCode;
    // this.$emit("on-mouseover", currentElementKey);
  }

  emitMouseleave() {
    this.hoverColor.currentHover = "black";
    // const hoverColor: any = this;
    // const defaultHoverColor = hoverColor;
    // hoverColor.currentHover = defaultHoverColor;
    // this.$emit("on-mouseover", -1);
  }

  emitClick() {
    this.$emit("on-click", this.currentElementKey);
  }

  startRotateAnimationOfArrowElement() {
    const { shown } = this;
    const { arrowElement } = this.$refs;
    const speed = 0.15;
    if (!arrowElement) return false;

    gsap.to(arrowElement, speed, {
      rotate: shown ? -180 : 0
    });
    return true;
  }

  // getNotificationCount() {
  //   const self = this;
  //   const adminNotificationCount: any = self;
  //   const hasNotification = self;
  //   const childList = self;
  //   const getNotificationValueType = typeof hasNotification;
  //   const initNotification : any = {
  //     boolean() {
  //       const resultCount = hasNotification;

  //       if (hasNotification) {
  //         const totalCount = self.getTotalCountOfNotification(
  //           hasNotification,
  //           childList
  //         );
  //         return totalCount > 0 ? totalCount : false;
  //       }

  //       return resultCount;
  //     },

  //     string() {
  //       const resultCount = adminNotificationCount[hasNotification];
  //       return resultCount > 0 ? resultCount : false;
  //     }
  //   };

  //   this.notificationCount = initNotification[getNotificationValueType]();
  // }

  getTotalCountOfNotification(notification: any, child: any) {
    const adminNotificationCount = notification;
    const childList = child;
    let total = 0;

    for (
      let childListIndex = 0;
      childListIndex < childList.length;
      childListIndex += 1
    ) {
      const hasNotificationString = childList[childListIndex].hasNotification;
      if (hasNotificationString !== false && adminNotificationCount) {
        const resultCount = adminNotificationCount[hasNotificationString];
        total += parseInt(resultCount, 10);
      }
    }

    return total > 0 ? total : false;
  }
}
</script>

<style lang="scss" scoped>
.p-navi-list-link-on-admin {
  &__link {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: rem(8) rem(12);
    text-align: left;

    &__icon {
      display: block;
      line-height: 1;
      margin-right: rem(8);
    }

    &__body {
      flex-grow: 1;
      display: block;
    }

    &__text {
      line-height: 1.6;
      font-size: rem(16);
      font-weight: bold;
      transition: all $transition-sec--fast ease-in;
      display: inline-block;
      vertical-align: middle;
    }

    &__notification {
      margin-left: rem(8);
      display: inline-block;
      vertical-align: middle;
    }

    &__arrow {
      line-height: 1;
    }
  }
}
</style>

<style lang="scss">
.p-navi-list-link-on-admin {
  &__link__icon {
    g,
    path {
      transition: all $transition-sec--fast ease-in;
    }
  }
}
</style>
